import React from "react";
import RIcon from "../../reservas/components/ReservasIcons";
import { PackageSummary } from "../../cumpleanos/BirthdaySteps";
import { isDepositBlocked, summarizeWindows } from "../../cumpleanos/birthdayModel";
import "../../cumpleanos/cumpleanos.css";

/**
 * "Cumpleaños" section of the club landing (mobile and desktop). Only rendered when the club exposes
 * `birthdays` (enabled in its configuration). The host passes its own section/title classes so it matches the
 * surrounding layout, and `onReserve` starts the birthday flow.
 */
const ClubBirthdaysSection = ({ birthdays, onReserve, className = "", titleClassName = "", id }) => {
  if (!birthdays) return null;

  const packages = Array.isArray(birthdays.packages) ? birthdays.packages : [];
  const windows = summarizeWindows(birthdays.windows);
  const blocked = isDepositBlocked(birthdays);
  const note =
    birthdays.mode === "approval"
      ? `Mandás una solicitud y el club te responde en hasta ${birthdays.responseHours} h. Pagás la seña solo si la acepta.`
      : "Pagás la seña online y el cumple queda confirmado al instante.";

  return (
    <div id={id} className={className}>
      <h3 className={titleClassName}>Cumpleaños</h3>
      <p className="bday-lead">Festejá tu cumple en el club: elegís el paquete, la fecha y el horario, y nosotros te reservamos la cancha.</p>

      {packages.length > 0 && (
        <div className="bday-packages">
          {packages.map((pkg) => (
            <div className="bday-package" key={pkg._id}>
              <PackageSummary pkg={pkg} />
            </div>
          ))}
        </div>
      )}

      <ul className="bday-facts">
        {windows.map((line) => (
          <li key={line}>
            <RIcon name="clock" width={14} height={14} /> {line}
          </li>
        ))}
        <li>
          <RIcon name="dollar" width={14} height={14} />{" "}
          {birthdays.depositPercent > 0 ? `Seña del ${birthdays.depositPercent}% para reservar` : "Sin seña: se paga todo en el club"}
        </li>
      </ul>

      <p className="bday-note">{note}</p>
      {blocked && <p className="bday-note warn">Este club todavía no está tomando cumpleaños con seña online.</p>}

      <button type="button" className="r-btn-primary" onClick={onReserve} disabled={packages.length === 0 || blocked}>
        Reservar mi cumple <RIcon name="arrowR" width={18} height={18} />
      </button>
    </div>
  );
};

export default ClubBirthdaysSection;
